var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCf({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512.001 512.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M503.172 423.721H8.828A8.829 8.829 0 0 1 0 414.893v-75.034h512v75.034a8.827 8.827 0 0 1-8.828 8.828z",
    fill: "#ffe15a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#73af00",
    d: "M0 255.997h512v83.86H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "M0 172.137h512v83.86H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M512 172.135H0V97.101a8.829 8.829 0 0 1 8.828-8.828h494.345a8.829 8.829 0 0 1 8.828 8.828L512 172.135z",
    fill: "#41479b"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff4b55",
    d: "M214.07 88.277h83.86v335.45h-83.86z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5 99.571l7.366 22.087 23.282.181c1.804.014 2.551 2.316 1.1 3.388l-18.73 13.83 7.022 22.198c.544 1.719-1.414 3.143-2.881 2.093L74.718 149.81l-18.941 13.538c-1.468 1.049-3.425-.374-2.881-2.093l7.022-22.198-18.727-13.83c-1.451-1.071-.703-3.373 1.1-3.388l23.282-.181 7.366-22.087c.57-1.711 2.99-1.711 3.561 0z",
    fill: "#ffe15a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCf);
export default __webpack_public_path__ + "static/media/cf.44a419141ee264a04c7f2d3028a50d5f.svg";
export { ForwardRef as ReactComponent };